import { Meta } from '@/components/common';
import { ReviewLinks } from '@/components/features/review-links';
import { Container } from '@/components/layout';

/**
 * Every design the signed-in user has sent to a dentist for review - their
 * own links only, on either licence type. No page heading: the shell's
 * header already says "Review Links".
 */
export function ReviewLinksPage() {
  return (
    <>
      <Meta title="Review Links" />

      <Container>
        <ReviewLinks />
      </Container>
    </>
  );
}
